import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import Text from './Text';
import Asset from './Asset';
import CTA from './CTA';
import ImageGallery from './ImageGallery';

import './cta-block.less';

const ALIGN_SMALL_BLOCK = ['left', 'right'];

const CTABlock = ({ textBlock, background, handleTrack }) => {
  const className = useClassName('ModularCTABlock');
  const containerExtraClasses = [];
  const contentExtraClasses = [];
  const ctaContainerExtraClasses = [];
  const titleExtraClasses = [];
  const textContainerClasses = [];

  if (textBlock?.assetPosition?.toLowerCase() === 'left') {
    containerExtraClasses.push('container-reverse');
  }
  if (!textBlock.asset) {
    contentExtraClasses.push('content-large');
    textContainerClasses.push('text-container-large');
  }
  if (textBlock.asset) {
    containerExtraClasses.push('container-clamp-height');
  }
  if (textBlock.textAlign) {
    contentExtraClasses.push(`content-align-${textBlock.textAlign}`);
    if (!textBlock.asset) contentExtraClasses.push('content-small');
  }
  if (ALIGN_SMALL_BLOCK.includes(textBlock.textAlign)) {
    ctaContainerExtraClasses.push('cta-container-small');
    if (!textBlock.asset && !textBlock.slider)
      ctaContainerExtraClasses.push('cta-container-aligned-right');
  }
  if (!ALIGN_SMALL_BLOCK.includes(textBlock.textAlign)) {
    titleExtraClasses.push('title-centered');
  }

  return (
    <div
      className={className(['container', ...containerExtraClasses])}
      style={{ background }}>
      <div className={className(['content', ...contentExtraClasses])}>
        <div className={className(['text-container', ...textContainerClasses])}>
          {textBlock.overline && (
            <Text
              text={textBlock.overline}
              key="overline"
              textAlign={textBlock?.textAlign}
            />
          )}
          {textBlock.title && (
            <div className={className(['title', ...titleExtraClasses])}>
              <Text
                text={textBlock.title}
                key="title"
                textAlign={textBlock?.textAlign}
              />
            </div>
          )}
          {textBlock.body && (
            <Text
              text={textBlock.body}
              key="body"
              textAlign={textBlock?.textAlign}
            />
          )}
        </div>

        {textBlock?.cta?.length && (
          <div
            className={className([
              'cta-container',
              ...ctaContainerExtraClasses,
            ])}>
            {textBlock.cta.map((cta, index) => (
              <CTA key={index} cta={cta} handleTrack={handleTrack} />
            ))}
          </div>
        )}
      </div>
      {(textBlock.asset || textBlock.slider) && (
        <div className={className('asset-container')}>
          {textBlock.slider ? (
            <ImageGallery imageGallery={textBlock.slider} />
          ) : (
            <Asset asset={textBlock.asset} />
          )}
        </div>
      )}
    </div>
  );
};

CTABlock.propTypes = {
  textBlock: PropTypes.object.isRequired,
  handleTrack: PropTypes.func,
};

CTABlock.defaultProps = {
  handleTrack: () => {},
};

export default CTABlock;
